// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8004';

// API Endpoints
export const API_ENDPOINTS = {
  SEARCH: `${API_BASE_URL}/search/`,
  SEARCH_LIST: `${API_BASE_URL}/search/list/`,
  SEARCH_DETAILS: (id: string | number) => `${API_BASE_URL}/search/${id}/`,
  SEARCH_KEYWORDS: (id: string | number) => `${API_BASE_URL}/search/${id}/keywords/`,
  SEARCH_CATEGORIES: (id: string | number) => `${API_BASE_URL}/search/${id}/category/`,
  SEARCH_ANALYSIS: (searchId: string | number) => `${API_BASE_URL}/search/${searchId}/analysis/`,
  CLUSTERS: `${API_BASE_URL}/cluster/`,
  CLUSTER_CREATE: `${API_BASE_URL}/cluster/`,
  CLUSTER_DETAILS: (id: string | number) => `${API_BASE_URL}/cluster/${id}/`,
  DA_SCORE: (searchId: string | number) => `${API_BASE_URL}/search/${searchId}/da/`,
  // Analytics endpoints
  ANALYTICS_OAUTH_CALLBACK: `${API_BASE_URL}/analytics/oauth/callback/`,
  ANALYTICS_OAUTH_INIT: `${API_BASE_URL}/analytics/oauth/init/`,
  ANALYTICS_OAUTH_SAVE: `${API_BASE_URL}/analytics/oauth/save/`,
  ANALYTICS_CONNECTIONS: `${API_BASE_URL}/analytics/connections/`,
  ANALYTICS_CONNECTION_DETAILS: (id: string | number) => `${API_BASE_URL}/analytics/connections/${id}/`,
  ANALYTICS_CONNECTION_DELETE: (id: string | number) => `${API_BASE_URL}/analytics/connections/${id}/delete/`,
  ANALYTICS_DASHBOARD: (id: string | number) => `${API_BASE_URL}/analytics/dashboard/${id}/`,
  // Add more endpoints as needed
  // USERS: `${API_BASE_URL}/users/`,
  // REPORTS: `${API_BASE_URL}/reports/`,
};

export const CLUSTER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
};

export const COMPETITION_LEVELS = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
};

// App Configuration
export const APP_CONFIG = {
  ITEMS_PER_PAGE: 20,
  MAX_SEARCH_RESULTS: 100,
  DEBOUNCE_DELAY: 300,
};

// Feature Flags
export const FEATURE_FLAGS = {
  ENABLE_ANALYTICS: true,
  ENABLE_REPORTS: true,
  ENABLE_USER_MANAGEMENT: true,
}; 